export default (value) => `{${value.join(',')}}`
